export const ROUTES = {
  HOME_PAGE: '/',
  LOGIN: '/login',
  LOGOUT: '/logout',
  SIGN_UP: '/signup',
  ADMINISTRATION: '/administration',
  NEWS: '/news',
  LANGUAGES: '/languages',
  USERS: '/users',
  AUTHORS: '/authors',
  PAYOUTS: '/payouts',
  KEYWORDS_VIOLATIONS: '/keywords-violations',
  COMPLAINTS: '/complaints',
  LOCATIONS: '/locations',
  BUSINESS_LINES: '/business-lines',
  INTERESTS: '/interests',
  LANGUAGES_SPOKEN: '/languages-spoken',
  SETTINGS: '/settings',
  CONTENT: '/content',
  RADAR: '/radar',
  GIFTS: '/gifts',
  PACKAGES: '/packages',
  PAID_SERVICES: '/paid-services',
  CHATS: '/chats',
  JJ_COINS: '/jj-coins',
  JJ_LIKES_PACKAGES: '/jj-likes-packages',
  JJ_FORTUNE: '/jj-fortune',
  JJ_LIKES: '/jj-likes',
  AGREEMENTS: '/agreements',
  JJ_PREMIUM: '/jj-premium',
  JJ_FUN: '/jj-fun',
  JJ_VIDEO: '/jj-video',
  STATISTICS: '/statistics',
  ACCRUAL_COINS: '/add-coins',
  JJ_INCOME: '/jj-income',
};
